export const AUTHORIZATION_ACTIONS = {
  USER_ROLE: 'AUTHORIZATION_USER_ROLE',
  USERS_ROLES: 'AUTHORIZATION_USERS_ROLES',
  SET_USER_ROLE: 'AUTHORIZATION_SET_USER_ROLE'
};